import { computed, Ref, ref } from "@vue/composition-api";

export const UseToggle = (
  initial_val: boolean
): [Readonly<Ref<Readonly<boolean>>>, () => void, (is_on: boolean) => void] => {
  const _is_on = ref(initial_val);
  const read_only_val = computed(() => _is_on.value);
  const toggle = () => (_is_on.value = !_is_on.value);
  const set_value = (is_on: boolean) => (_is_on.value = is_on);
  return [read_only_val, toggle, set_value];
};
